import React, { Component } from "react";  
import './ErrorBoundary.css';  
  
class ErrorBoundary extends Component {  
  constructor(props) {  
    super(props);  
    this.state = { hasError: false, error: null };  
  }  
  
  static getDerivedStateFromError(error) {  
    return { hasError: true, error };  
  }  
  
  componentDidCatch(error, errorInfo) {  
    console.error("Error caught by ErrorBoundary:", error, errorInfo);  
  }  
  
  render() {  
    if (this.state.hasError) {  
      return (  
        <div className="error-container">  
          <div className="running-duck">  
            <img  
              src="https://media.giphy.com/media/YTzh3zw4mj1XpjjiIb/giphy.gif"  
              alt="Running Duck"  
            />  
            <div className="error-message">  
              {this.state.error && this.state.error.toString()}  
            </div>  
          </div>  
        </div>  
      );  
    }  
  
    return this.props.children;  
  }  
}  
  
export default ErrorBoundary;  
